import Image from 'next/image';
import { cn } from '@/lib/utils';
import type { JobCompany } from '@/services/jobs/model';

export function CompanyLogo({
  job,
  size = 66,
  className,
  imageClassName,
}: {
  job: { company: JobCompany };
  size?: number;
  className?: string;
  imageClassName?: string;
}) {
  const src = job.company.logo || '/images/logo-upzi.svg';

  return (
    <div
      className={cn(
        'border-alias-outline bg-surface-pure relative shrink-0 overflow-hidden rounded-xl border',
        className
      )}
      style={{ width: size, height: size }}
    >
      <Image
        src={src}
        alt={`Logo ${job.company.name || 'công ty'}`}
        fill
        sizes={`${size}px`}
        quality={85}
        loading="lazy"
        className={cn('object-contain p-1', imageClassName)}
      />
    </div>
  );
}
